import { render, staticRenderFns } from "./vipseven.vue?vue&type=template&id=5a51c6ce&"
import script from "./vipseven.vue?vue&type=script&lang=js&"
export * from "./vipseven.vue?vue&type=script&lang=js&"
import style0 from "./vipseven.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports